module.exports = __webpack_public_path__ + "static/media/background_noimage.ebe2ebb7.png";